export default import.meta.ROLLDOWN_FILE_URL_QWlASV9lxehQB4YS50rglQ